__turbopack_context__.v({
  "accordionSummary": "ZuVBzq_accordionSummary",
  "btnSummaryEdit": "ZuVBzq_btnSummaryEdit",
  "certify": "ZuVBzq_certify",
  "whatWillYouDo": "ZuVBzq_whatWillYouDo",
});
